module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "branch-commit"
  }, [(_vm.hasCommitRef) ? _c('div', {
    staticClass: "icon-container hidden-xs"
  }, [(_vm.tag) ? _c('i', {
    staticClass: "fa fa-tag",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.tag) ? _c('i', {
    staticClass: "fa fa-code-fork",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.hasCommitRef) ? _c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    staticClass: "ref-name hidden-xs",
    attrs: {
      "href": _vm.commitRef.ref_url,
      "data-container": "body",
      "title": _vm.commitRef.name
    }
  }, [_vm._v("\n    " + _vm._s(_vm.commitRef.name) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "commit-icon js-commit-icon",
    domProps: {
      "innerHTML": _vm._s(_vm.commitIconSvg)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "commit-sha",
    attrs: {
      "href": _vm.commitUrl
    }
  }, [_vm._v("\n    " + _vm._s(_vm.shortSha) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "commit-title flex-truncate-parent"
  }, [(_vm.title) ? _c('span', {
    staticClass: "flex-truncate-child"
  }, [(_vm.hasAuthor) ? _c('user-avatar-link', {
    staticClass: "avatar-image-container",
    attrs: {
      "link-href": _vm.author.path,
      "img-src": _vm.author.avatar_url,
      "img-alt": _vm.userImageAltDescription,
      "tooltip-text": _vm.author.username
    }
  }) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "commit-row-message",
    attrs: {
      "href": _vm.commitUrl
    }
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")])], 1) : _c('span', [_vm._v("\n      Cant find HEAD commit for this branch\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b42ba16"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/commit.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3b42ba16"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/commit.vue
// module chunks = common_vue